import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ITaskModel } from '../../model/task.model';
import { ReferenceTaskType } from '../../model/referenceTaskType.enum';
import { TooltipTextComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-task-response-renderer',
    imports: [TooltipTextComponent],
    templateUrl: './task-response-renderer.component.html',
    styleUrl: './task-response-renderer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskResponseRendererComponent {
    taskType: typeof ReferenceTaskType = ReferenceTaskType;

    @Input()
    task!: ITaskModel;

    get displayResponse(): string {
        if (this.task.type === ReferenceTaskType.MULTI_SELECT && this.task.response) {
            return this.task.response
                .split(',')
                .map((response) => response.trim())
                .join(', ');
        }
        return this.task.response;
    }
}
